import React from 'react';
import { Reveal } from './Reveal';
import { Briefcase } from 'lucide-react';

export const CareersSection: React.FC = () => {
  return (
    <section id="careers" className="py-24 bg-stone-50 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl font-heading font-bold text-gray-900 mb-4">Careers at Villa Avoils</h2>
            <div className="h-1 w-20 bg-avo-gold mx-auto rounded-full mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Join our team and be part of a sustainable agricultural revolution.
            </p>
          </div>
        </Reveal>

        <div className="max-w-4xl mx-auto">
          <Reveal delay={100}>
            <div className="bg-white rounded-3xl shadow-sm border border-stone-100 p-12 text-center">
              <div className="w-20 h-20 bg-stone-100 text-stone-400 rounded-full flex items-center justify-center mx-auto mb-8">
                <Briefcase size={40} />
              </div>
              
              <h3 className="text-3xl font-heading font-bold text-gray-900 mb-6">Current Vacancies</h3>
              
              <div className="bg-stone-50 border border-stone-100 rounded-2xl p-8 mb-10">
                <p className="text-xl text-gray-600 font-medium italic">
                  "There are currently no open vacancies at Villa Avoils International Limited."
                </p>
              </div>

              <div className="max-w-2xl mx-auto">
                <p className="text-gray-600 mb-8 leading-relaxed">
                  The application deadline for our recent openings has passed. However, we are always looking for passionate individuals to join our growing team. You may still submit your resume for future consideration.
                </p>

                <div className="pt-8 border-t border-stone-100">
                  <p className="text-sm text-gray-500 uppercase tracking-widest font-bold mb-4">Submit for Future Opportunities</p>
                  <a 
                    href="mailto:info@villaavoils.com"
                    className="text-2xl font-bold text-avo-forest hover:text-avo-main transition-colors block mb-4"
                  >
                    info@villaavoils.com
                  </a>
                  <p className="text-stone-400 text-sm">
                    We will review your profile and contact you if a suitable position becomes available.
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
